window.PointsEarningConstants = ({
    events: {
        fileUploaded: 'fileUploaded',
        successfullyUploaded: 'Successfully uploaded'
    },
    elements: {
        vitalityFileUploader: 'vitality-file-uploader',
        button: 'button',
        globalConstants: {
            blur: 'blur',
            blurChange: 'blur change',
            change: 'change',
            checked: ':checked',
            click: 'click',
            dateFormat: 'd/m/Y',
            emptyString: '',
            failed: 'Failed',
            hash: '#',
            id: 'id',
            selected: ' :selected',
            visible: ':visible',
            minimumValueLength: 3
        },
        id: {
            activitiesDropdownTarget: '#activities-dropdown',
            activityLocationValidationTarget: '#activity-location-validation',
            activityWarningMessageTarget: '#activity-warning-message',
            additionalInfoFieldTarget: '#additional-info-field',
            additionalInfoFieldTitleTarget: '#additional-info-field-title',
            checkbox: 'points-earning-form-terms-checkbox',
            checkboxBox: 'points-earning-checkbox-box',
            checkboxBoxTarget: '#points-earning-checkbox-box',
            checkboxTarget: '#points-earning-form-terms-checkbox',
            checkboxValidationTarget: '#points-earning-form-terms-checkbox-validation',
            datePickerIdTarget: '#points-earning-activity-datepicker-validation',
            datePickerLabelTarget: '#points-earning-date-picker-label',
            pointsEarningActivityForm: '#points-earning-activity-form',
            pointsEarningActivityFormFields: '#points-earning-activity-form-fields',
            pointsEarningActivityFormTarget: '#points-earning-activity-form',
            pointsEarningCalendarButton: 'points-earning-activity-datepicker_btn',
            pointsEarningCalendarButtonTarget: '#points-earning-activity-datepicker_btn',
            pointsEarningDatepickerParent: 'points-earning-activity-datepicker-parent',
            pointsEarningDatepickerParentTarget: '#points-earning-activity-datepicker-parent',
            pointsEarningDatepickerTarget: '#points-earning-activity-datepicker',
            pointsEarningFormButtonTarget: '#points-earning-form-button',
            pointsEarningFormButtonValidationTarget: '#points-earning-form-button-validation',
            pointsEarningUploadValidationMessageTarget: '#points-earning-upload-validation-message',
            topFieldValidationTarget: '#topFieldValidation',
            uploaderOutput: 'vitality-file-uploader-output',
            uploaderOutputTarget: '#vitality-file-uploader-output',
            vaccinationsDropdownTarget: '#vaccinations-dropdown',
            vaccinationsDropdownWrapperTarget: '#vaccinations-dropdown-wrapper',
            vaccineValidationMessageTarget: '#vaccinations-dropdown-validation',
        },
        buttons: {
            datePickerButtonTarget: '.vds-form button',
            formButtonsTarget: '.vds-form button'
        },
        classes: {
            activityListWarningsTarget: '.activity-list-warnings',
            additionalInfoFieldValidationTarget: '.additional-info-field-validation',
            additionalInfoInputTarget: '.additional-info-input',
            buttonDisabled:'vds-button--disabled',
            checkboxInputTarget: '.vds-checkbox__input',
            checkboxLabelTarget: '.vds-checkbox__label',
            datePickerContainerTarget: '.vds-form__datepicker',
            datePickerInputTarget: '.vds-form__datepicker-input',
            datePickerInvalidTarget: '.vds-form__datepicker--invalid',
            datePickerInvalid: 'vds-form__datepicker--invalid',
            firstAdditionalInfoField: 'first-additional-info-field',
            firstAdditionalInfoFieldTarget: '.first-additional-info-field',
            flatpickrWindowTarget: '.flatpickr-calendar',
            formTarget: '.vds-form',
            formValidation: 'form-validation',
            formValidationTarget: '.form-validation',
            itemInvisible: 'vds-visibility-hidden',
            itemRemoved: 'vds-item-removed',
            listOfActivityWarningsTarget: '.list-of-activity-warnings',
            listOfVaccinationWarningsTarget: '.list-of-vaccination-warnings',
            onSubmitValidation: 'pea-submit-validation',
            onSubmitValidationTarget: '.pea-submit-validation',
            parentContainerTarget: '.vds-main-content__primary-container',
            redErrorBoxForCheckbox: 'vds-checkbox--invalid',
            redErrorBoxForCheckboxTarget: '.vds-checkbox--invalid',
            redErrorBoxForInputField: 'vds-form__input--invalid',
            redErrorBoxForInputFieldTarget: '.vds-form__input--invalid',
            regexError: 'regex-error',
            uploadSuccessfulMessageTarget: '.vds-notification--success',
            vaccinationListWarningsTarget: '.vaccination-list-warnings',
            vaccineWarnings: '.vaccine-warning-message'
        }
    }
});
